import { render } from "./ResendPrompt.vue?vue&type=template&id=0d06272e&ts=true"
import script from "./ResendPrompt.vue?vue&type=script&lang=ts"
export * from "./ResendPrompt.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__